import { debounce } from "lodash";

export function tooltips() {

    let tooltips = document.querySelectorAll('[data-tooltip]');
    if (tooltips.length == 0) return;

    tooltips.forEach(tooltip => {

        let tooltipItem = tooltip.querySelector('[data-tooltip-region]') as HTMLElement;
        let tooltipTrigger = tooltip.querySelector('[data-tooltip-trigger]');
        let tooltipClose = tooltip.querySelector('[data-tooltip-close]');
        let isTouched = false;
        if (!tooltip.classList.contains('initialized')) {
        tooltip.addEventListener('mouseover', function () {
            handleTooltipPosition(tooltipItem, tooltipTrigger);
        });
       tooltip.addEventListener('touchstart', function (e) {
                isTouched = true;
       });
        tooltip.addEventListener('mouseout', function () {
            handleTooltipPosition(tooltipItem, tooltipTrigger);
        });

        tooltipTrigger.addEventListener('click', function () {
            if (!tooltipItem.classList.contains('open')) {
                openTooltip(tooltipItem, tooltipTrigger);
                handleTooltipPosition(tooltipItem, tooltipTrigger);
            }
            else {
                closeTooltip(tooltipItem, tooltipTrigger);
                handleTooltipPosition(tooltipItem, tooltipTrigger);
            }
        });
        tooltipClose.addEventListener('click', function () {
            tooltipItem.classList.add('override-hover');
            closeTooltip(tooltipItem, tooltipTrigger);
            if (!isTouched) {
                setTimeout(() => {
                    tooltipItem.classList.remove('override-hover');
                }, 500);
            }
        });

        window.addEventListener('resize', debounce(() => {
            if (tooltipItem.classList.contains('open')) {
                handleTooltipPosition(tooltipItem, tooltipTrigger);
            }
        }, 50));
    }
        tooltip.classList.add('initialized');
    });

}


const handleOutsideClick = (e: MouseEvent) => {
    let openTooltip = document.querySelector('[data-tooltip-region].open');
    let openTooltipTrigger = document.querySelector('[data-tooltip-trigger][aria-expanded="true"]');
    let tooltipTrigger = document.querySelector('[data-tooltip-trigger][aria-expanded="true"]');
    if (openTooltip && !openTooltip.contains(e.target as Node) && openTooltipTrigger !== e.target) {
        closeTooltip(openTooltip, tooltipTrigger);

        document.removeEventListener('mousedown', handleOutsideClick);
    }
    
}


const closeTooltip = function (tooltip, tooltipTrigger) {
    tooltip.classList.add('closed');
    tooltip.classList.remove('open');
    tooltipTrigger.attributes['aria-expanded'].value = 'false';
}

const openTooltip = function (tooltip, tooltipTrigger) {
    if (tooltip.classList.contains('override-hover')) {
        tooltip.classList.remove('override-hover');
    }
    tooltip.classList.add('open');
    tooltip.classList.remove('closed');
    tooltipTrigger.attributes['aria-expanded'].value = 'true';

    document.addEventListener('mousedown', handleOutsideClick);
}

const handleTooltipPosition = function(tooltip, tooltipTrigger) {
    const screenPadding = 32;

    const placeholderRect = tooltipTrigger.getBoundingClientRect();
    const dropdownRect = tooltip.getBoundingClientRect();

    const dropdownRightX = dropdownRect.x + dropdownRect.width;
    const placeholderRightX = placeholderRect.x + placeholderRect.width;

    if (dropdownRect.x < 0) {
        tooltip.style.left = '0';
        tooltip.style.right = 'auto';
        tooltip.style.transform = `translateX(${-placeholderRect.x + screenPadding}px)`;
        if (-placeholderRect.x + screenPadding < 0) {
            tooltip.style.setProperty('--caret-position', `${-placeholderRect.x + screenPadding}px`);
        }
        else {
            tooltip.style.setProperty('--caret-position', `-16px`);
        }
    } else if (dropdownRightX > window.outerWidth) {
        tooltip.style.left = 'auto';
        tooltip.style.right = '0';
        tooltip.style.transform = `translateX(${(window.outerWidth - placeholderRightX) - screenPadding}px)`;
        tooltip.style.setProperty('--caret-position', `-150px`);
    }
}